import styled from 'styled-components';
import getAcaraColors from 'styleVariables/getAcaraColors';

export default styled.div`
  display: inline-block;
  position: relative;
  font-size: 1.2rem;
  width: 100%;
  line-height: 1.5rem;
  margin-bottom: 1rem;
  color: ${props => props.error ? getAcaraColors('light').warningColor : getAcaraColors('light').secondaryText};

  ${props => props.hint ? `
    display: flex;
    align-items: center;
    gap: 1rem;
  ` : ''}

  ${props => props.thisStyles}
  ${props => props.labelStylesCss}
  
`;
